import t from "../../Actions/ReportsAction/types";

const intitialState = {
  ticketDispenserList: [],
  ticketValidationList: [],
  getPaymentReceiptData: "",
};

const Reducer = (state = intitialState, action) => {
  switch (action.type) {
    case t.FETCH_TICKET_DISPENSER_LIST: {
      return { ...state, ticketDispenserList: action.payload };
    }
    case t.FETCH_VALIDATION_LIST: {
      return { ...state, ticketValidationList: action.payload };
    }
    case t.FETCH_PAYMENT_DOWNLOAD_DATA: {
      return { ...state, getPaymentReceiptData: action.payload };
    }
    default:
      return state;
  }
};

export default Reducer;
